import React, { useState } from 'react';

const inputStyle = {
  width: '100%', background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px',
  padding: '13px 16px', fontSize: '15px', color: '#fff',
  outline: 'none', transition: 'border-color 0.2s', fontFamily: 'Inter, sans-serif',
  boxSizing: 'border-box',
};

export default function Demo() {
  const [form, setForm] = useState({ name: '', org: '', email: '', phone: '', size: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [focused, setFocused] = useState('');

  const handle = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <section id="book-a-demo" style={{ padding: '100px 0', background: 'rgba(255,255,255,0.01)' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 32px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '72px', alignItems: 'start' }} className="demo-grid">
          {/* Left */}
          <div>
            <div style={{ display: 'inline-block', background: 'rgba(45,106,79,0.12)', border: '1px solid rgba(82,183,136,0.2)', borderRadius: '100px', padding: '5px 16px', fontSize: '12px', color: '#52b788', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '24px' }}>
              Free Demo
            </div>
            <h2 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(28px,3.5vw,44px)', fontWeight: 800, letterSpacing: '-1.2px', marginBottom: '20px', lineHeight: 1.15 }}>
              See ATLAS ITSM in action
            </h2>
            <p style={{ fontSize: '16px', color: '#a8b4cc', lineHeight: 1.7, marginBottom: '40px' }}>
              Book a personalised 30-minute demo with the Aiprus team. We'll walk you through the modules relevant to your org, answer every question, and give you a sandbox to explore.
            </p>

            {[
              { icon: '📅', title: '30-min live walkthrough', sub: 'Tailored to your team size and workflows' },
              { icon: '🧪', title: 'Sandbox access', sub: 'Explore the platform hands-on after the call' },
              { icon: '💬', title: 'Q&A with the product team', sub: 'Get answers from the people who built it' },
            ].map(i => (
              <div key={i.title} style={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
                <div style={{ fontSize: '24px', flexShrink: 0, marginTop: '2px' }}>{i.icon}</div>
                <div>
                  <div style={{ fontSize: '15px', color: '#fff', fontWeight: 600 }}>{i.title}</div>
                  <div style={{ fontSize: '13px', color: '#a8b4cc', marginTop: '3px' }}>{i.sub}</div>
                </div>
              </div>
            ))}

            <div style={{ marginTop: '40px', padding: '20px 24px', background: 'rgba(45,106,79,0.1)', border: '1px solid rgba(82,183,136,0.2)', borderRadius: '12px' }}>
              <div style={{ fontSize: '13px', color: '#52b788', fontWeight: 600, marginBottom: '6px' }}>📞 Prefer to call?</div>
              <div style={{ fontSize: '14px', color: '#a8b4cc' }}>Reach us at <span style={{ color: '#fff' }}>contact@aiprus.com</span> or visit <span style={{ color: '#fff' }}>www.aiprus.com</span></div>
            </div>
          </div>

          {/* Right — Form */}
          <div style={{ background: '#141c35', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '20px', padding: '40px 36px' }}>
            {submitted ? (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <div style={{ fontSize: '52px', marginBottom: '20px' }}>✅</div>
                <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '24px', fontWeight: 700, marginBottom: '12px' }}>You're booked!</h3>
                <p style={{ color: '#a8b4cc', fontSize: '15px', lineHeight: 1.6 }}>
                  Thanks, <strong style={{ color: '#fff' }}>{form.name}</strong>. The Aiprus team will reach out to <strong style={{ color: '#fff' }}>{form.email}</strong> within 24 hours to confirm your demo slot.
                </p>
                <button onClick={() => { setSubmitted(false); setForm({ name:'',org:'',email:'',phone:'',size:'',message:'' }); }}
                  style={{ marginTop: '28px', background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', color: '#a8b4cc', padding: '10px 24px', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>
                  Submit another request
                </button>
              </div>
            ) : (
              <form onSubmit={submit}>
                <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '20px', fontWeight: 700, marginBottom: '28px' }}>Book Your Free Demo</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '13px', color: '#a8b4cc', marginBottom: '8px', fontWeight: 500 }}>Full Name *</label>
                    <input required value={form.name} onChange={handle('name')} placeholder="Swati Agarwal"
                      style={{ ...inputStyle, borderColor: focused === 'name' ? 'rgba(82,183,136,0.5)' : 'rgba(255,255,255,0.1)' }}
                      onFocus={() => setFocused('name')} onBlur={() => setFocused('')} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: '13px', color: '#a8b4cc', marginBottom: '8px', fontWeight: 500 }}>Organisation *</label>
                    <input required value={form.org} onChange={handle('org')} placeholder="Aiprus Software"
                      style={{ ...inputStyle, borderColor: focused === 'org' ? 'rgba(82,183,136,0.5)' : 'rgba(255,255,255,0.1)' }}
                      onFocus={() => setFocused('org')} onBlur={() => setFocused('')} />
                  </div>
                </div>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', color: '#a8b4cc', marginBottom: '8px', fontWeight: 500 }}>Work Email *</label>
                  <input required type="email" value={form.email} onChange={handle('email')} placeholder="swati@company.com"
                    style={{ ...inputStyle, borderColor: focused === 'email' ? 'rgba(82,183,136,0.5)' : 'rgba(255,255,255,0.1)' }}
                    onFocus={() => setFocused('email')} onBlur={() => setFocused('')} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '13px', color: '#a8b4cc', marginBottom: '8px', fontWeight: 500 }}>Phone</label>
                    <input value={form.phone} onChange={handle('phone')} placeholder="+91 98765 43210"
                      style={{ ...inputStyle, borderColor: focused === 'phone' ? 'rgba(82,183,136,0.5)' : 'rgba(255,255,255,0.1)' }}
                      onFocus={() => setFocused('phone')} onBlur={() => setFocused('')} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: '13px', color: '#a8b4cc', marginBottom: '8px', fontWeight: 500 }}>Team Size</label>
                    <select value={form.size} onChange={handle('size')}
                      style={{ ...inputStyle, borderColor: focused === 'size' ? 'rgba(82,183,136,0.5)' : 'rgba(255,255,255,0.1)', cursor: 'pointer' }}
                      onFocus={() => setFocused('size')} onBlur={() => setFocused('')}>
                      <option value="" style={{ background: '#141c35' }}>Select size</option>
                      <option value="1-10" style={{ background: '#141c35' }}>1–10 people</option>
                      <option value="11-50" style={{ background: '#141c35' }}>11–50 people</option>
                      <option value="51-200" style={{ background: '#141c35' }}>51–200 people</option>
                      <option value="200+" style={{ background: '#141c35' }}>200+ people</option>
                    </select>
                  </div>
                </div>
                <div style={{ marginBottom: '28px' }}>
                  <label style={{ display: 'block', fontSize: '13px', color: '#a8b4cc', marginBottom: '8px', fontWeight: 500 }}>What are you looking to solve?</label>
                  <textarea value={form.message} onChange={handle('message')} rows={3} placeholder="Describe your current IT service challenges..."
                    style={{ ...inputStyle, resize: 'vertical', borderColor: focused === 'message' ? 'rgba(82,183,136,0.5)' : 'rgba(255,255,255,0.1)' }}
                    onFocus={() => setFocused('message')} onBlur={() => setFocused('')} />
                </div>
                <button type="submit" style={{ width: '100%', background: 'linear-gradient(135deg, #2d6a4f, #40916c)', color: '#fff', padding: '15px', borderRadius: '10px', fontSize: '16px', fontWeight: 700, border: 'none', cursor: 'pointer', transition: 'opacity 0.2s, transform 0.2s', boxShadow: '0 8px 32px rgba(45,106,79,0.35)' }}
                  onMouseEnter={e => { e.target.style.opacity = '0.9'; e.target.style.transform = 'translateY(-1px)'; }}
                  onMouseLeave={e => { e.target.style.opacity = '1'; e.target.style.transform = 'none'; }}>
                  Book My Free Demo →
                </button>
                <p style={{ textAlign: 'center', fontSize: '12px', color: '#5a6a8a', marginTop: '14px' }}>No credit card required. No commitment. Just a conversation.</p>
              </form>
            )}
          </div>
        </div>
      </div>
      <style>{`@media(max-width:900px){ .demo-grid{ grid-template-columns:1fr !important; } }`}</style>
    </section>
  );
}
